var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-body {\r\n\tbackground-color: #003f66;\r\n\tmin-height: 100%;\r\n}\r\n\r\n.background-body:before {\r\n\tcontent: \"\";\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\topacity: 0.08;\r\n\tposition: fixed;\r\n\tbackground-size: cover;\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-image: url(" + escape(require("../../../assets/img/background.1.jpg")) + ");\r\n}\r\n\r\n.background-body:after {\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tcontent: \"\";\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tposition: absolute;\r\n\tbackground: -webkit-gradient(linear, left top, left bottom, from(#003F66), to(transparent));\r\n\tbackground: linear-gradient(#003F66, transparent);\r\n}\r\n\r\n.background-body .card {\r\n\tz-index: 2;\r\n\tborder: none;\r\n\tbackground: transparent;\r\n}\r\n\r\n.background-body .card .card-block {\r\n\twidth: 400px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/src/app/view/login/login.component.css
// module id = ../../../../../src/app/view/login/login.component.css
// module chunks = main